export var DefaultEffects = {
  // commented values are the defaults for Fluent
  elevation4: '0 0 5px 0 rgba(0,0,0,.4)',
  elevation8: '0 0 5px 0 rgba(0,0,0,.4)',
  elevation16: '0 0 5px 0 rgba(0,0,0,.4)',
  elevation64: '0 0 5px 0 rgba(0,0,0,.4)',
  roundedCorner2: '0px' // 2

};